<div class="navigation">
  @if (!iemService.isIEM()) {
    <div class="my-views-container" (clickOutside)="closeMyViewsMenu()">
      <div class="my-views-node"
           [ngClass]="{'is-selected': isMyViewsMenuOpen(), 'pointer': savedFiltersMenuItems().length > 0}"
           [matTooltip]="savedFiltersMenuItems().length === 0 ? mySavedViewsTexts.empty_tooltip : ''"
           matTooltipPosition="after"
           (click)="toggleMyViewsMenu($event)">
        <app-icon [svgIcon]="IconsEnum.bookmark"></app-icon>
        <span class="my-views-title">{{ mySavedViewsTexts.title }} ({{ savedFiltersMenuItems().length }})</span>
        <app-icon [svgIcon]="IconsEnum.chevron_right"></app-icon>
      </div>
      @if (isMyViewsMenuOpen()) {
        @if (savedFiltersMenuItems().length > 0) {
          <div class="my-views-menu">
            <app-ui-menu-basic
              [items]="savedFiltersMenuItems()"
              [forceMenuOpen]="true"
              [showCloseIcon]="true"
              [width]="'280px'"
              (closed)="closeMyViewsMenu()">
            </app-ui-menu-basic>
          </div>
        }
      }
    </div>
  }
  <div class="navigation__tree">
    <app-tree-view [data]="treeData"></app-tree-view>
  </div>
  <app-nav-license class="navigation__version"></app-nav-license>
</div>
